import { NavigateFunction } from "react-router-dom";

// Holds React Router's navigate function so non-React code (the native bridge's
// `navigate`) can do SPA navigation. App registers it on mount.

let navigateFn: NavigateFunction | null = null;

export function setNavigate(fn: NavigateFunction | null): void {
  navigateFn = fn;
}

export function navigateTo(path: string): void {
  if (navigateFn) {
    navigateFn(path);
  } else {
    // Fallback if the app hasn't registered navigate yet (native also has its
    // own location.href fallback).
    window.location.href = path;
  }
}
